// extracted by mini-css-extract-plugin
export var active = "index-module--active--ead51";
export var customTag = "index-module--customTag--d2717";
export var isClickable = "index-module--isClickable--276d0";